module.exports = __webpack_public_path__ + "images/737827edc3613ecc8eb04fdb797bec32.svg";